// extracted by mini-css-extract-plugin
module.exports = {"off":"StatusIcon_off__1rTwE","container":"StatusIcon_container__2EEt1","noMargin":"StatusIcon_noMargin__2m50A","img":"StatusIcon_img__eZew6"};